import { mapState as rootMapState } from 'pinia';
import bannerMixins from '../../mixins/banner';
import banner from '../../components/banner.vue';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './async-data';
import useStore from './_store';
import { usePageStore } from '@/store';
import colorMixin from '@/modules/color-mixin';
import spaceMixin from '@/modules/space-mixin';

export default {
    i18next: {
        ns: 'md-hero'
    },
    asyncData: mapAsyncData(asyncData),
    mixins: [bannerMixins, spaceMixin(), colorMixin()],
    _getUseStore: useStore,
    data: function() {
        return {
            contentType: 'text',
            align: 'center',
            title: '',
            subTitle: '',
            titlePic: '',
            showShadow: false,
            // searchStyle: 'search-bar',
            searchStyle: 'search-group',
            buttons: [],
            searchGroupList: [],
            searchGroupTabs: [],
            layout: '',
            searchGroupConfig: {},
            configFilter: null,
            imgAlign: 'center',
            nameType: 1,
            nameRequired: false,
            phoneRequired: false,
            showAgreement: false,
            agreementData: {},
            searchbarPlaceholder: '',
            searchBtnText: '',
            newTabToListing: false,
            searchButton: {
                textColor: '',
                backgroundColor: ''
            }
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            mlsOrgs: store => store.page?.mlsOrgs
        }),
        searchBarLayout({ isMobileSize, layout }) {
            return isMobileSize ? 'column' : layout;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        computedSearchBtnText() {
            if (this.mdData?.data?.theme == 'template8') {
                return this.searchBtnText || this.$t('md-hero.search_v8');
            }
            return this.searchBtnText || this.$t('md-hero.search');
        },
        useType() {
            if (this.useMobileSettings && this.isMobileSize) {
                return this.mobileType || this.type;
            } else {
                return this.type;
            }
        },
        searchGroupTabList({ searchGroupTabs, searchGroupList = [] }) {
            if (searchGroupList.length) {
                return searchGroupTabs.filter(v =>
                    searchGroupList.includes(Number(v.id)));
            }
            return searchGroupTabs;
        }
    },
    created() {
        if (
            this.showAgreement &&
            (this.searchStyle === 'search-bar' ||
                this.searchStyle === 'search-group')
        ) {
            this.getAgreementData();
        }
    },
    methods: {
        //  Prevent element click events inside the video screen from bubbling to the video ， cause the video to open / switch off
        avoidEmitMedia(e) {
            e.avoidEmitMedia = 1;
        },
        doVideoPlay(e) {
            this.$refs.banner && this.$refs.banner.doVideoPlay();
        },
        getAgreementData() {
            if (this.mlsOrgs && this.mlsOrgs.length > 0) {
                this.agreementData = this.mlsOrgs[0];
            }
        },
        getBannerStyle({  offsetTop, type, autoHeight, BANNER_TYPE }) {
            if (type == BANNER_TYPE.fullScreen) {
                let minHeight = Math.max(
                    window.innerHeight - offsetTop,
                    800
                );
                return {
                    minHeight: Math.max(minHeight, autoHeight)
                }
            }
        }
    },
    components: {
        banner
    },
    provide() {
        return {
            newTabToListing: this.newTabToListing
        };
    }
};
